<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>项目名称：</label>
                    <el-select v-model="search_Obj.f_project_id" clearable placeholder="请选择" style="width: 200px" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('project_group')" :key="'project_group'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <div class="searchGroup">
                    <label>日期：</label>
                    <el-date-picker v-model="search_Obj.f_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </div>
                <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column prop="project_id" label="项目名称" sortable="custom" width="200">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.project_id, "project_group") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="path" label="接口地址"></el-table-column>
                    <el-table-column prop="count" label="访问次数" width="130"></el-table-column>
                    <el-table-column prop="date" label="日期" width="170"></el-table-column>
                </el-table>
            </div>
            <div class="pageBox">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"

export default {
    name: 'InterfaceVisit',
    mixins: [listutil],
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '接口访问统计',
            menu_id: 9999,
            pagesize: 10,
            list_url: "/api/admin/interfacevisit/list",
            search_Obj: {
                f_project_id: '',
                f_date: '',
            },
            del_Obj:{
                url:'/api/admin/interfacevisit1/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['project_group'],
        };
    },
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
    }
};
</script>